import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const OwnerDashboard: FC = () => {
  const { t } = useTranslation('dashboard.OwnerDashboard');

  return (
    <div>
      <h2>{t('ownerDashboardTitle')}</h2>
      <p>{t('ownerDashboardDescription')}</p>
      {/* Add your dashboard content here */}
      {/* This could include charts, statistics, tables, etc. */}
    </div>
  );
};

export default OwnerDashboard;
